module.exports = __webpack_public_path__ + "img/09.273e232b.png";